var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.b(),style:(_vm.styleSizeName)},[_c('div',{class:_vm.b('title'),domProps:{"innerHTML":_vm._s(_vm.titleFormatter && _vm.titleFormatter(_vm.dataChart))}}),_c('div',{ref:_vm.id,style:(_vm.styleChartName)})])}
var staticRenderFns = []

export { render, staticRenderFns }